import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './contexts/LanguageContext';
import { useScrollReveal } from './hooks/useScrollReveal';
import Layout from './components/layout/Layout';
import Preloader from './components/ui/Preloader';
import Home from './pages/Home';
import About from './pages/About';
import Departments from './pages/Departments';
import DepartmentDetail from './pages/DepartmentDetail';
import News from './pages/News';
import Contact from './pages/Contact';

// Styles
import './styles/tokens.css';
import './styles/globals.css';

// Effect wrapper to initialize hooks inside Router
const AppEffects = () => {
  useScrollReveal();
  return null;
};

function App() {
  const [isAppLoading, setIsAppLoading] = useState(true);

  useEffect(() => {
    // Standard window load event to ensure all assets are ready
    const handleLoad = () => {
      // Minimum loading time to show the preloader animation beautifully
      setTimeout(() => setIsAppLoading(false), 1200);
    };

    if (document.readyState === 'complete') {
      handleLoad();
    } else {
      window.addEventListener('load', handleLoad);
      return () => window.removeEventListener('load', handleLoad);
    }
  }, []);

  return (
    <LanguageProvider>
      {isAppLoading && <Preloader />}
      <Router>
        <AppEffects />
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/departments" element={<Departments />} />
            <Route path="/departments/:slug" element={<DepartmentDetail />} />
            <Route path="/news" element={<News />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </Layout>
      </Router>
    </LanguageProvider>
  );
}

export default App;
